import { useAppSelector } from "../../store";

const MetadataTab = () => {
    const storyline = useAppSelector(state => state.storyline.storyline);
    const slide = useAppSelector(state => state.storyline.currentParagraph);

    return <div className="table-container">
        <table className="table bordered no-header key-value">
            <tbody>
                <tr>
                    <td className="heading-cell">
                        Storyline
                    </td>
                    <td>
                        {storyline.name}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Template
                    </td>
                    <td>
                        {slide.templateName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Chapter
                    </td>
                    <td>
                        {slide.chapterName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Page
                    </td>
                    <td>
                        {slide.pageName}
                    </td>
                </tr>
                <tr>
                    <td className="heading-cell">
                        Paragraph
                    </td>
                    <td>
                        {slide.name}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>;
};

export default MetadataTab;